<script setup lang="ts">
definePage({
  meta: {
    requiresAuth: true,
  },
})
</script>

<template>
  <div class="mycard rounded-b-lg p-4">
    <h2 class="text-2xl font-bold">API Tokens</h2>
    <p class="text-gray-600 dark:text-gray-400">Manage your API tokens here.</p>
    <div class="mt-4">
      <button class="btn btn-primary">Create New Token</button>
    </div>
  </div>
</template>
